import { render } from "./data_privacy.html?vue&type=template&id=5c1a0b1a&external"
import script from "./data_privacy.js?vue&type=script&lang=js&external"
export * from "./data_privacy.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__